<template>
  <div class="rightTable">
    <div class="title">
      <div>
        <el-button :disabled="!selectList.length" icon="el-icon-download" type="primary" plain size="small"
          @click="batchDownLoad">
          下载
        </el-button>
      </div>
      <div>
        <el-input v-model="keyWords" placeholder="请输入文件名称" size="small" suffix-icon="el-icon-search"></el-input>
      </div>
    </div>
    <div class="table">
      <el-table ref="table" v-loading="tableLoading" :data="tableData"
        element-loading-text="数据加载中..." height="100%" border @selection-change="selectChange">
        <template slot="empty">
          <img :src="zanwu" alt="">
          <p style="font-size:16px;">暂无数据</p>
        </template>
        <el-table-column type="selection" width="55" align="center">
        </el-table-column>
        <el-table-column label="文件名" prop="">
          <template slot-scope="scope">
            <div style="display:flex;align-items: center" class="colCheck">
              <!-- 轻量化图标 -->
              <fileLightFlag :row="scope.row" @updateLight="updateLight" />
              <img :src="className(scope.row)"
                style=" flex-shrink: 0; margin:0 5px; -webkit-user-drag: none; -moz-user-select: none; -ms-user-select: none; -khtml-user-select: none; user-select: none; " />
              <el-link v-if="scope.row.isRead === 1" type="primary">
                <span class="tabLinkSpan" :title="scope.row.fileName"
                  @click="preview(scope.row)">{{ scope.row.fileName }}</span>
              </el-link>
              <el-link v-else type="primary">
                <span class="tabLinkSpan" :title="scope.row.fileName"
                  @click="preview(scope.row)">{{ scope.row.fileName }}</span>
              </el-link>
              <!-- <span class="hand" @click="preview(scope.row)">{{ scope.row.fileName }}</span> -->
            </div>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip align="center" label="路径" prop="filePath"> </el-table-column>
        <el-table-column show-overflow-tooltip align="center" label="操作" prop="">
          <template slot-scope="scope">
            <i class="el-icon-download hand" title="下载" @click="download(scope.row.fileId)"></i>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip align="center" label="大小" prop="readableFileSize"> </el-table-column>
        <el-table-column show-overflow-tooltip align="center" label="修改人" prop="checkInUser"> </el-table-column>
        <el-table-column show-overflow-tooltip align=" center" label="修改时间" prop="checkInDate"> </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import checkRegionService from "@/CommonDP/service/checkRegion-service";
import { filePreviewV1, tableRowIcon } from "@/CommonDP/utils/docPublic";
import { downloadFile, downloadUrltoken } from "@/CommonDP/utils";
import docService from "@/CommonDP/service/doc-service";
import fileLightFlag from "@/CommonDP/components/fileLightFlag";
import flowService from "@/CommonDP/service/flow-service";
export default {
  name: "",
  components: { fileLightFlag },
  mixins: [],
  props: {},
  data() {
    return {
      zanwu: require("@/CommonDP/assets/暂无数据.png"),
      keyWords: "",
      tableData: [],
      tableDataStore: [],
      tableLoading: false,
      selectList: [],
      flowBusinessId: "",
      currentNodeName: ''
    };
  },
  computed: {
    ...mapState({
      prjInfo: state => state.projectMg.prjObj,
      enterpriseId: state => state.enterprise.enterpriseId
    })
  },
  watch: {
    keyWords(val) {
      this.selectList = [];
      if (val === "") {
        this.$emit("getTableData");
      } else {
        this.tableData = this.tableDataStore.filter(item => this.filterKeyword(item, val));
      }
    }
  },
  created() {},
  mounted() {},
  methods: {
    updateLight(row, type) {
      const prjId = this.enterpriseId;
      row.status = "1";
      const status = row.status;
      let messageType;
      type === 1 ? (messageType = "优先轻量化操作") : (messageType = "重新轻量化操作");
      docService
        .updateLight(prjId, row.fileId, row.versionIds)
        .then(res => {
          if (res.result === "0") {
            row.status = "1";
            this.$message.success(`${messageType}成功`);
          } else {
            row.status = status;
            this.$message.warning(`${messageType}失败`);
          }
        })
        .catch(() => {
          row.status = status;
        });
    },
    filterKeyword(item, name) {
      const keyArr = ["fileName"];
      let flag = false;
      while (keyArr[0] && !flag) {
        if (item[keyArr.shift()].includes(name)) flag = true;
      }
      return flag;
    },

    getTableData() {
      return this.tableDataStore;
    },

    async setTableData(businessId, currentNodeName) {
      this.tableLoading = true;
      this.keyWords = '';
      this.currentNodeName = currentNodeName;
      this.selectList = [];
      this.tableData = [];
      this.tableDataStore = [];
      if (businessId) {
        const res = await checkRegionService.getFileListByFlowBusinessId(businessId);
        this.tableData = res.data || [];
        this.tableDataStore = res.data || [];
      }
      this.tableLoading = false;
    },
    setFlowBusinessId(flowBusinessId) {
      this.flowBusinessId = flowBusinessId;
    },
    selectChange(selection) {
      this.selectList = selection;
    },
    async preview(row) {
      if (this.flowBusinessId) {
        // 只有在待审批里才有flowBusinessId
        const params = {
          flowBusinessId: this.flowBusinessId,
          fileId: row.fileId,
          fileName: row.fileName
        };
        const res = await flowService.readFlowFile(params);
        if (res.result === "0") row.isRead = 1;
      }

      const data = {
        fileId: row.fileId,
        versionId: row.versionIds || 1,
        parentId: row.parentId,
        fileType: Number(row.fileType),
        status: row.status
      };
      filePreviewV1(data, this.tableData);
    },
    download(fileId) {
      const fileUrl = downloadUrltoken(this.prjInfo.prjId, fileId);
      downloadFile(fileUrl);
    },
    batchDownLoad() {
      const fileIdList = this.selectList.map(item => item.fileId);
      const { prjId } = this.prjInfo;
      var params = {
        fileIdList,
        prjId
      };
      checkRegionService.downloadFileZip(params).then(response => {
        const fileName = "附件" + ".zip";
        if ("msSaveOrOpenBlob" in navigator) {
          window.navigator.msSaveOrOpenBlob(response, fileName);
          return;
        } else {
          const link = document.createElement("a");
          const blob = response;
          link.style.display = "none";
          link.href = URL.createObjectURL(blob);
          link.setAttribute("download", decodeURI(fileName));
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      });
    },
    className(row) {
      return tableRowIcon(row);
    }
  }
};
</script>

<style scoped lang="scss">
.rightTable {
  width: calc(100% - 300px);
  height: 100%;
  display: flex;
  flex-direction: column;
  .title {
    width: 100%;
    padding: var(--middle-space) var(--big-space);
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .table {
    width: 100%;
    padding: 0 var(--big-space) var(--middle-space);
    height: 1px;
    flex-grow: 1;
  }
}
.hand {
  cursor: pointer;
}
</style>
